// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".am-pm[data-v-7b8afa62] {\n  line-height: 1.1;\n}", ""]);
// Exports
module.exports = exports;
